import { render } from "./Spoiler.vue?vue&type=template&id=0793c560&scoped=true"
import script from "./Spoiler.vue?vue&type=script&lang=js"
export * from "./Spoiler.vue?vue&type=script&lang=js"

import "./Spoiler.vue?vue&type=style&index=0&id=0793c560&scoped=true&lang=scss"

import exportComponent from "../../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-0793c560"]])

export default __exports__